let modalAddToCartButtonClicked = false;

document.addEventListener('DOMContentLoaded', onDOMContentLoaded);

function onDOMContentLoaded() {
    if (window.location.href.includes("/pages/build-your-own-bundle")) {
        let observer = new MutationObserver(onMutation);
        observer.observe(document.body, { attributes: true });

        let modalButtons = document.querySelectorAll('.open-modal-btn');
        modalButtons.forEach(function (button) {
            button.addEventListener('click', onModalButtonClick);
        });
    }
}

function onMutation(mutationsList, observer) {
    mutationsList.forEach(function (mutation) {
        if (mutation.type === 'attributes' && document.body.classList.contains('ajax-cart-open')) {
            if (modalAddToCartButtonClicked) {
                document.body.classList.remove('ajax-cart-open');
                modalAddToCartButtonClicked = false;
            }
        }
    });
}

function onModalButtonClick() {
    setTimeout(function () {
        let modal = document.querySelector('.modal-content');
        if (modal) {
            let addToCartButton = modal.querySelector('#modal-add-to-cart');
            if (addToCartButton) {
                addToCartButton.addEventListener('click', onAddToCartButtonClick);
            }
        }
    }, 500);
}

function onAddToCartButtonClick(event) {
    modalAddToCartButtonClicked = true;
}